module.exports = __webpack_public_path__ + "static/media/303RowLabel--CSharp.31b0598e.svg";